import axios from "axios";
import offlineConfig from "./offlineMode";
import mockDataProvider from "../store/mock/mockDataProvider";

export function setupOfflineInterceptors() {
  if (!offlineConfig.isOfflineMode) {
    return;
  }

  console.log("🔌 Offline mode enabled - Setting up interceptors");

  // Request interceptor to handle offline mode
  axios.interceptors.request.use(
    async (config) => {
      if (offlineConfig.useMockData && config.url) {
        console.log("📦 Intercepting API call:", config.url);
        console.log("   Method:", config.method);
        console.log("   Data:", config.data);

        // Get mock data for this endpoint
        try {
          const mockData = await mockDataProvider.getMockData(
            config.url,
            config.method.toLowerCase(),
            config.data
          );

          if (mockData !== null) {
            const dataType = Array.isArray(mockData)
              ? `${mockData.length} items`
              : typeof mockData;
            console.log(`✅ Returning ${dataType} for:`, config.url);

            // Instead of making the request, throw a special error with mock data
            const mockError = new Error("MOCK_RESPONSE");
            mockError.config = config;
            mockError.mockData = mockData;
            throw mockError;
          } else {
            console.log("⚠️  No mock data found for:", config.url);
          }
        } catch (error) {
          if (error.message === "MOCK_RESPONSE") {
            throw error;
          }
          console.error("❌ Error getting mock data:", error);
        }
      }

      if (offlineConfig.disableSSL && config.url) {
        // Convert https to http for local development
        config.url = config.url.replace("https://", "http://");
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor to handle mock responses
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      // Check if this is our special mock response error
      if (error.message === "MOCK_RESPONSE" && error.mockData !== undefined) {
        // Return a mock response
        return {
          data: error.mockData,
          status: 200,
          statusText: "OK (Mock)",
          headers: {},
          config: error.config,
        };
      }

      // Handle other errors in offline mode
      if (offlineConfig.useMockData && error.config) {
        console.log("📦 Handling failed API call:", error.config.url);

        try {
          const mockData = await mockDataProvider.getMockData(
            error.config.url,
            error.config.method.toLowerCase(),
            error.config.data
          );

          if (mockData !== null) {
            const dataType = Array.isArray(mockData)
              ? `${mockData.length} items`
              : typeof mockData;
            console.log(
              `✅ Returning ${dataType} for failed call:`,
              error.config.url
            );
            return {
              data: mockData,
              status: 200,
              statusText: "OK (Mock)",
              headers: {},
              config: error.config,
            };
          }
        } catch (mockError) {
          console.error("❌ Error getting mock data:", mockError);
        }
      }

      // If not in offline mode or no mock data available, return the original error
      return Promise.reject(error);
    }
  );
}

export default setupOfflineInterceptors;
